import React from 'react';
import Helmet from 'react-helmet';
import {
  AGENCY_REGISTRATION_APPLICATION_PAGE,
  HEADER_CONSTANTS,
  PARTNER_COMPANY_REGISTER_LOAD_FROM,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import AgencyRegistrationApplicationForm from '../components/AgencyRegistrationApplicationForm';
import { RegisterHeader } from '../components/AgencyRegistrationApplicationHeader';
import {
  FORM_MODE,
  useAgencyRegistrationApplicationForm,
} from '../components/useAgencyRegistrationApplicationForm';
import { PartnerCompanyPersonalRegister } from './PartnerCompanyPersonalRegister';

const AgencyRegistrationApplicationRegister = props => {
  const {
    formValues,
    errorMessages,
    agencyUserCandidates,
    isDifferent,
    onSelectUserCandidate,
    onAddUserCandidate,
    onDeleteUserCandidate,
    onSelectCompany,
    onSetFile,
    onDeleteFile,
    canApply,
    handleApply,
    canTemporarySave,
    handleTemporarySave,
    handleFormClose,
    movePartnerCompanyRegister,
    closePartnerCompanyRegister,
    isPartnerCompanyRegisterVisible,
    canEditCompanyAgentTo,
    canEditMemorandumFile,
    selectedPartnerCompanyData,
    setSelectedPartnerCompanyData,
    isPartnerCompanyAddDialogOpen,
    setIsPartnerCompanyAddDialogOpen,
    partnerCompanyAddDialogSearchParam,
    setPartnerCompanyAddDialogSearchParam,
  } = useAgencyRegistrationApplicationForm(
    FORM_MODE.REGISTER,
    undefined,
    props.view.state.id
  );

  if (isPartnerCompanyRegisterVisible) {
    return (
      <PartnerCompanyPersonalRegister
        onSelectCompany={onSelectCompany}
        onClose={closePartnerCompanyRegister}
        isAgencyRegistrationApplication={true}
        view={{
          state: {
            loadFrom: PARTNER_COMPANY_REGISTER_LOAD_FROM.AGENCY_REGISTER,
            listData: selectedPartnerCompanyData,
          },
        }}
      />
    );
  }

  return (
    <div className='contruction-slide-view show'>
      <Helmet>
        <title>
          {`${HEADER_CONSTANTS.conference} - ${
            AGENCY_REGISTRATION_APPLICATION_PAGE.REGISTER.TEXT
          }`}
        </title>
      </Helmet>
      <div className='contruction-slide-view__view'>
        <MasterPageHeader
          title={
            <div className='slide-view__title'>
              {AGENCY_REGISTRATION_APPLICATION_PAGE.REGISTER.TEXT}
            </div>
          }
          onClose={handleFormClose}
        />
        <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
          <div className='contruction-detail-view'>
            <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
              <div className='contruction-detail-view__header'>
                <button className='btn-text--sm' onClick={handleFormClose}>
                  <i className='i-back--blue i-2x vertical-middle' />
                  {AGENCY_REGISTRATION_APPLICATION_PAGE.LIST.TEXT}
                </button>
              </div>
              <RegisterHeader
                {...{
                  canApply,
                  handleApply,
                  canTemporarySave,
                  handleTemporarySave,
                }}
              />
              <div className='contruction-detail-view__bar' />
              <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                <AgencyRegistrationApplicationForm
                  {...{
                    formValues,
                    errorMessages,
                    agencyUserCandidates,
                    isDifferent,
                    onSelectUserCandidate,
                    onAddUserCandidate,
                    onDeleteUserCandidate,
                    onSelectCompany,
                    onSetFile,
                    onDeleteFile,
                    movePartnerCompanyRegister,
                    canEditCompanyAgentTo,
                    canEditMemorandumFile,
                    setSelectedPartnerCompanyData,
                    isPartnerCompanyAddDialogOpen,
                    setIsPartnerCompanyAddDialogOpen,
                    partnerCompanyAddDialogSearchParam,
                    setPartnerCompanyAddDialogSearchParam,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencyRegistrationApplicationRegister;



// WEBPACK FOOTER //
// ./src/pages/AgencyRegistrationApplicationRegister.jsx